
export const validateEmail = (email: string): boolean => {

	// Regular expression for basic email validation
	const re = /\S+@\S+\.\S+/;

	return re.test(email);
};